export const isOdd = num => num % 2
